import React, { useEffect, useState, useRef } from 'react';
import logo75 from '../assets/images/75Years.png';
import logo from '../assets/images/logo.png';
import { useLocation } from "react-router-dom";
import '../assets/style/smart-report.css';
import PatientInfo from '../components/patientInfo';
import Benefits from '../components/benefits';
import TableOfContent from '../components/tableOfContent';
import SneakPeak from '../components/sneakpeak';
import ReportSummary from '../components/reportsummary';
import Disclaimer from '../components/disclaimer';
import References from '../components/references';
import { ImmediateTests } from '../components/recommendedTestPDF';
import { DietRecommendarions, LifeStyleRecommendations } from '../components/recommendedDietLifestylePDF';
import CriticalParemeters from '../components/criticalParameters';
import ReportDetailsList from '../components/reportDetailsList';
import TrustInfo from '../components/trust';
import { QRCodeCanvas } from 'qrcode.react';
import fetchSmartReportData, { sendScreenshotWithLabNumberForPDF } from '../services/apiServices';
import html2canvas from 'html2canvas';
import Preloader from '../components/preloading';

function encodeBase64(data) {
    return btoa(data); // Encoding lab number and last name in base64 format
}
function decodeBase64(encodedData) {
    return decodeURIComponent(escape(atob(encodedData))); // Decode and handle special characters
}
function PdfGenerator() {

    const contentRef = useRef();
    const [data, setReportData] = useState(null);
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const lno = queryParams.get('lno');
    const lastName = queryParams.get('lastName')
    const hasPrinted = useRef(false); // prevents repeated calls

    // Fetch data on mount or when 'lno' changes
    useEffect(() => {
        const fetchData = async () => {
            try {
                const fetchedData = await fetchSmartReportData(lno, encodeBase64(lastName));
                //const fetchedData = await fetchSmartReportData(lno)
                if (!fetchedData || !fetchedData.data) {
                    if (fetchedData && fetchedData.message === "No record found!") {
                        setReportData({ message: "No record found!" });
                    } else {
                        setReportData(null);
                    }
                } else {
                    setReportData(fetchedData);
                }
            } catch (error) {
             //   console.log('Error fetching data:', error);
                setReportData(null);
            }
        };

        if (lno) {
            fetchData(); // Directly call the function without assignment
        }
    }, [lno]);

    const captureScreenshot = (section) => {
        return new Promise((resolve, reject) => {
            const originalWidth = section.style.width;
            const originalHeight = section.style.height;
            section.style.width = '1100px';
            section.style.height = '1560px';
            html2canvas(section).then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                if (imgData) {
                    resolve(imgData);
                } else {
                    reject('Failed to capture image data');
                }
                section.style.width = originalWidth;
                section.style.height = originalHeight;
            }).catch((error) => {
                section.style.width = originalWidth;
                section.style.height = originalHeight;
                reject(error);
            });
        });
    };

    const handlePrint = async () => {
        const screenshots = [];
        const sections = contentRef.current.querySelectorAll('.section');
        if (sections.length === 0) {
            console.error('No sections found for screenshot capture.');
            return;
        }
        for (let section of sections) {
            try {
                const imgData = await captureScreenshot(section);
                if (imgData) {
                    screenshots.push(imgData);
                } else {
                    console.warn('No image data captured for this section.');
                }
            } catch (error) {
                console.error('Error capturing screenshot:', error);
            }
        }

        if (screenshots.length === 0) {
            console.error('No screenshots captured.');
            return;
        }
        
        try {
            await sendScreenshotWithLabNumberForPDF(apiLabNumber, lastName, screenshots);

            // const response = await fetch('https://staging2.lalpathlabs.com/SmartReportAPI/api/GeneratePdf', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json',
            //     },
            //     body: JSON.stringify(requestData),
            // });
            // const data = await response.json();
           // const data = await sendScreenShotsWithLabNumber.json();
          //  console.log('Response from backend:', data);
        } catch (error) {
            console.error('Error sending data:', error);
        }
    };

    useEffect(() => {
        // if (data) {
        //     handlePrint();
        // }
        if (
            (data?.data?.patientDetails?.PackageCode === "WM128" ||
                data?.data?.patientDetails?.PackageCode === "WR653") &&
                Array.isArray(data?.data?.smartReportListDetails) &&
                data.data.smartReportListDetails.length >= 1 &&
                !hasPrinted.current){
                     handlePrint();
                    hasPrinted.current = true;
        }
        else if (data && Array.isArray(data?.data?.smartReportListDetails) && data.data.smartReportListDetails.length > 10 && !hasPrinted.current) {
            handlePrint();
            hasPrinted.current = true;
        }  // list details is 10 by jitendra
    }, [data]);

    if (!data) {
        return <Preloader />;  // Show Preloader while data is being fetched
    }

    if (data.message === "No record found!") {
        return <PatientInfo data={data} />;
    }

    // Get lab number and QR URL
    const apiLabNumber = data?.data?.patientDetails.LabNumber;
    // const qrurl = `http://localhost:3001/verify-lastname/?lno=${lno}`;
    const qrurl = `https://smartreport.lalpathlabs.com/verify-lastname/?lno=${lno}`
   // console.log(qrurl)

   // for getting country code
    const patientInfo = data?.data?.patientDetails || {};
    const getCountry = () => {
        const Company = (patientInfo.Company || '').toUpperCase();
        if (Company === 'BANG') {
            return 'BANGLADESH';
        } else if (Company === 'NEP') {
            return 'NEPAL';
        } else {
            return 'BHARAT';
        }
    };
    const country = getCountry();

    return (
        <>
            <div className='container-top' ref={contentRef}>

                {/* page 1 */}
                <PatientInfo data={data} />
                {/* Page 2 */}
                <Benefits />
                {/* page3 */}
                {/* <!--table of content--> */}
                <section className="section section-2" id="tableContent">
                    <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <TableOfContent />

                        </div>
                    </div>
                </section>
                {/* <!-- end table of content--> */}

                {/* page 4 */}
                <section className="section section-3" id="report-overview">
                    <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <SneakPeak data={data} />
                        </div>
                        <div className="row">
                            <div className="container-1">
                                <div className="col-12">
                                    <ul className="indicator">
                                        <li className="normal">Within Normal Limit</li>
                                        <li className="abnormal">Need attention</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="container-1">
                                <div className="col-12 mt-0">
                                <a target='_blank' href={`https://www.lalpathlabs.com/swasth-fit-packages-full-body-checkups`}>Click here</a> to read more about your vital parameters through our blogs.
                                </div>
                                <div className="col-12 mt-3">
                                    {apiLabNumber && (
                                        <QRCodeCanvas value={qrurl} size={150} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* page 5 */}
                {/* <!--Summary page--> */}

                <ReportSummary data={data} />

                {/* <!--end  Summary page--> */}

                {/* crital parameters */}

                <CriticalParemeters data={data} />

                {/* page 8 */}

                <ReportDetailsList data={data} />

                {/* page 12 */}
                <section className="section section-5" id="diet-recomendation">
                    <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="container-1 benefits">
                                <DietRecommendarions data={data} />
                                <LifeStyleRecommendations data={data} />
                            </div>
                        </div>
                    </div>
                </section>


                {/* page 13 */}
                <ImmediateTests data={data} />
                


                {/* page 14 */}
                <section className="section section-7 " id="references">
                    <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="container-1 benefits">

                                <References />
                                <Disclaimer />
                            </div>
                        </div>
                    </div>
                </section>

                {/* page15 */}
                 {country === 'BHARAT' && (
                <section className="section section-8 " style={{ backgroundColor: '#fffaf4' }}>
                   
                       <TrustInfo data={data} />              
                    
                    {/* <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>
                        <div className="row last-page-content-wrapper" >
                            <div className="container-1 ">
                                <div className="custom-center">
                                    <div className="tagline">
                                        BHARAT KA <br /> <span>VISHWAS</span>
                                    </div>

                                    <div className="about-success">
                                        <div>
                                            <img alt="" src={hospital} />
                                            <div className="count">11K+</div>
                                            <div className="count-name">Hospital & Clinic Partners</div>
                                        </div>
                                        <div>
                                            <img alt="" src={testMenu} />
                                            <div className="count">~5K</div>
                                            <div className="count-name">Test Menu</div>
                                        </div>
                                        <div>
                                            <img alt="" src={qualitycheck} />
                                            <div className="count">50+</div>
                                            <div className="count-name">Quality Checks</div>
                                        </div>
                                        <div>
                                            <img alt="" src={serviceCenter} />
                                            <div className="count">6K+</div>
                                            <div className="count-name">Patient
                                                Service Centres</div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div> */}
                </section>
                 )}

            </div>
        </>
    );

}

export default PdfGenerator;